var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncomingVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_774_6313",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_774_6313)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.26523 18.975C3.61523 19.325 4.04273 19.5 4.54773 19.5H15.9325C16.4375 19.5 16.865 19.325 17.215 18.975C17.565 18.625 17.74 18.1974 17.74 17.6923V13.1152L20.4862 15.8615C20.6337 16.009 20.7994 16.0458 20.9832 15.972C21.1672 15.8983 21.2592 15.7577 21.2592 15.55V8.45C21.2592 8.24233 21.1672 8.10167 20.9832 8.028C20.7994 7.95417 20.6337 7.991 20.4862 8.1385L17.74 10.8848V6.30775C17.74 5.80258 17.565 5.375 17.215 5.025C16.865 4.675 16.4375 4.5 15.9325 4.5H4.54773C4.04273 4.5 3.61523 4.675 3.26523 5.025C2.91523 5.375 2.74023 5.80258 2.74023 6.30775V17.6923C2.74023 18.1974 2.91523 18.625 3.26523 18.975ZM10.75 13.9704H8.55375L13.2578 9.2666C13.4026 9.1216 13.475 8.94594 13.475 8.7396C13.475 8.5331 13.4026 8.35743 13.2578 8.2126C13.1129 8.06777 12.9357 7.99693 12.726 8.0001C12.5163 8.00327 12.3422 8.0741 12.2037 8.2126L7.5 12.9166V10.7204C7.5 10.5079 7.42817 10.3297 7.2845 10.1859C7.141 10.0422 6.96291 9.97035 6.75025 9.97035C6.53775 9.97035 6.35958 10.0422 6.21575 10.1859C6.07192 10.3297 6 10.5079 6 10.7204V14.5666C6 14.8226 6.08666 15.0372 6.26 15.2104C6.43317 15.3837 6.64775 15.4704 6.90375 15.4704H10.75C10.9625 15.4704 11.1407 15.3985 11.2845 15.2549C11.4282 15.1114 11.5 14.9333 11.5 14.7206C11.5 14.5081 11.4282 14.3299 11.2845 14.1861C11.1407 14.0423 10.9625 13.9704 10.75 13.9704Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomingVideo);
export default __webpack_public_path__ + "static/media/incoming_video.00f32e896263889e2509b97561991cea.svg";
export { ForwardRef as ReactComponent };